import { useSelector } from '@stores';
import { useCallback, useEffect, useState } from 'react';

export const useStandard = () => {
  const [characterNumber, setCharacterNumber] = useState<{
    maleNumber?: number | string;
    femaleNumber?: number | string;
    wholeGenderNumber?: number | string;
    isWholeGenderNumberChecked?: boolean;
  } | null>(null);

  const storedStandardChildOptionValue = useSelector((state) => state.standard);

  const characterNumberLimit = 3;

  const getMaleNumberMenuItems = useCallback(() => {
    let maleNumberLimit = 3;

    if (!characterNumber) {
      maleNumberLimit = characterNumberLimit;
    } else if (characterNumber?.femaleNumber !== '4+') {
      maleNumberLimit = characterNumberLimit - Number(characterNumber?.femaleNumber);
    } else {
      maleNumberLimit = characterNumberLimit;
    }

    const maleNumberMenuItems = [];

    let i = 0;

    while (i <= maleNumberLimit) {
      maleNumberMenuItems.push(i);
      i++;
    }

    maleNumberMenuItems.push('4+');

    return maleNumberMenuItems;
  }, [characterNumber?.femaleNumber]);

  const getFemaleNumberMenuItems = useCallback(() => {
    let femaleNumberLimit = 3;

    if (!characterNumber) {
      femaleNumberLimit = characterNumberLimit;
    } else if (characterNumber?.maleNumber !== '4+') {
      femaleNumberLimit = characterNumberLimit - Number(characterNumber?.maleNumber);
    } else {
      femaleNumberLimit = characterNumberLimit;
    }

    const femaleNumberMenuItems = [];

    let i = 0;

    while (i <= femaleNumberLimit) {
      femaleNumberMenuItems.push(i);
      i++;
    }

    femaleNumberMenuItems.push('4+');

    return femaleNumberMenuItems;
  }, [characterNumber?.maleNumber]);

  // 필터 초기화 클릭하여 stored character number가 null이 될 시 인원수 Chip value도 initialize
  useEffect(() => {
    if (!storedStandardChildOptionValue.characterNumber) {
      setCharacterNumber(null);
    }
  }, [storedStandardChildOptionValue.characterNumber]);

  return {
    characterNumber,
    setCharacterNumber,
    getMaleNumberMenuItems,
    getFemaleNumberMenuItems
  };
};
